import {
  ErrorType,
  type DceNotAllowedByOrder,
  type ErrorValues
} from 'commons/utils/errors/error-type';

import { ShippingDetailsResponseDto } from 'domains/shipping-details/types/shipping-details-response-dto';

type Error = {
  type: ErrorType | null;
  order?: ShippingDetailsResponseDto;
  values?: ErrorValues;
  dceNotAllowedByOrder?: DceNotAllowedByOrder;
};

export type ShippingDetailsState = {
  error: Error | undefined;
};

export type Action =
  | { type: 'SET_ERROR'; payload: Error }
  | { type: 'CLEAR_ERROR' };

const initialState: ShippingDetailsState = {
  error: undefined
};

const shippingDetailsReducer = (
  state: ShippingDetailsState,
  action: Action
): ShippingDetailsState => {
  switch (action.type) {
    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload
      };

    case 'CLEAR_ERROR':
      return {
        ...state,
        error: undefined
      };

    default:
      return state;
  }
};

export { initialState, shippingDetailsReducer };
